// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"79cc08f6","239":"b67fbdf4","732":"5420f41a","946":"35510ccf"}[chunkId] + ".chunk.js";
};